module.exports = __webpack_public_path__ + "thumbnail-c8c8f6010706701daa2609916c300ec4.png";